import { openBlock as o, createElementBlock as t, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ e("path", { d: "M8.123 6.374c.028-.433.34-.713.812-.713.473 0 .785.262.785.623s-.161.56-.69.858c-.567.316-.794.677-.747 1.31v.216H9.39v-.207c0-.38.151-.57.7-.876.585-.326.887-.741.887-1.337 0-.913-.784-1.536-1.965-1.536-1.266 0-1.984.678-2.003 1.662h1.115Zm-.057 4.156c0-.416.36-.76.794-.76.435 0 .794.344.794.76 0 .415-.36.758-.794.758-.435 0-.794-.344-.794-.759Z" }, null, -1), l = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M12.63 1H3.37C2.614 1 2 1.587 2 2.31v11.38c0 .723.614 1.31 1.37 1.31h9.26c.756 0 1.37-.587 1.37-1.31V2.31C14 1.587 13.386 1 12.63 1ZM3.37 2.355h.614V13.69h-.567L3.37 2.355Zm9.213 11.29-7.181.036V2.346l7.18-.036v11.335Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  n,
  l
];
function r(s, h) {
  return o(), t("svg", c, [...d]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
